export default __webpack_public_path__ + "static/media/cover_3.46f33905.jpg";